import { Navigate, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ exitUser, children }) => {
    const { pathname, search } = useLocation();
    const sliptPath = pathname.split("/");
    const authentication = ["login", "signup", "verify-otp", "forgot-password", "create-password"]
    const isAuthPage = authentication.includes(sliptPath?.[1]);
    const isCheckoutPage = pathname.includes("/checkout");
    const isUserVerifyPage = pathname.includes("/user-verification");
    const isProfilePage = pathname.includes("/profile");
    const isChatPage = pathname.includes("/chat");
    const isNotificationPage = pathname.includes("/notification");


    if (exitUser && isAuthPage) return <Navigate to="/" replace />;
    if (!exitUser && isCheckoutPage) return <Navigate to={`/user-verification?Type=service`} replace />;
    if (exitUser && isUserVerifyPage) {
        // Event bookings go back to the event they came from, not the service checkout
        const params = new URLSearchParams(search);
        if (params.get("Type") === "event") {
            params.delete("Type");
            return <Navigate to={`/event-categories/events/list/details?${params}`} replace />;
        }
        return <Navigate to="/services/details/checkout" replace />;
    }
    if (!exitUser && (isProfilePage || isChatPage || isNotificationPage)) return <Navigate to="/" replace />;

    return children;
};
